import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import { Alert } from '@/components/ui/alert'

export function OrganizationDashboardSettingDialogs({
  next,
  ticked,
  pending,
  error,
  onTick,
  onClose,
  onConfirm,
}: {
  next: boolean | null
  ticked: boolean
  pending: boolean
  error: Error | null
  onTick: (ticked: boolean) => void
  onClose: () => void
  onConfirm: () => void
}) {
  const action = next ? 'Turn on' : 'Turn off'
  return (
    <Dialog
      open={next !== null}
      onOpenChange={(open) => {
        if (!open && !pending) onClose()
      }}
    >
      <DialogContent
        aria-describedby={next ? 'org-dashboard-facts' : 'org-dashboard-off-description'}
        onEscapeKeyDown={(event) => {
          if (pending) event.preventDefault()
        }}
        onInteractOutside={(event) => {
          if (pending) event.preventDefault()
        }}
      >
        <DialogHeader>
          <DialogTitle>{action} the organization dashboard?</DialogTitle>
        </DialogHeader>
        {next ? (
          <>
            <ul
              id="org-dashboard-facts"
              className="list-disc space-y-1.5 pl-5 text-body-sm text-foreground"
            >
              <li>
                Roster managers and billing contacts see their organization&apos;s people by name.
              </li>
              <li>
                Shown: event bookings, courses and grades, purchases, groups, membership level.
              </li>
              <li>Never shown: emails, phone numbers, email clicks.</li>
            </ul>
            <div className="mt-4 flex items-start gap-3">
              <Checkbox
                id="org-dashboard-notice"
                checked={ticked}
                disabled={pending}
                onCheckedChange={(checked) => onTick(checked === true)}
              />
              <Label
                htmlFor="org-dashboard-notice"
                className="text-body-sm font-normal leading-snug"
              >
                Our privacy notice tells members that their employer can see this activity.
              </Label>
            </div>
          </>
        ) : (
          <p id="org-dashboard-off-description" className="text-body-sm text-foreground">
            Organizations stop seeing the dashboard straight away.
          </p>
        )}
        {error && <Alert>{error.message}</Alert>}
        <DialogFooter>
          <Button type="button" variant="outline" disabled={pending} onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            disabled={pending || (next === true && !ticked)}
            onClick={onConfirm}
          >
            {action}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
